import {AfterViewInit, Component, inject, Input} from '@angular/core';
import {SearchContainer} from "../../../core/definitions/search-container";
import {SearchObject} from "../../../core/definitions/search-object";
import {SearchResultSelectionsService} from "../../search-result-selections.service";
import {FeatureFlagsService} from "../../../core/feature-flags.service";
import {RouterLink} from "@angular/router";
import {MatTooltipModule} from "@angular/material/tooltip";
import {TranslateModule} from "@ngx-translate/core";
import {ThumbnailItemComponent} from "../../../shared/thumbnail-item/thumbnail-item.component";
import {SearchResultPackageIndicator} from "../search-result-package-indicator/search-result-package-indicator";

@Component({
  selector: 'app-search-result-view-thumbnail-v2',
  imports: [
    RouterLink,
    MatTooltipModule,
    TranslateModule,
    ThumbnailItemComponent,
    SearchResultPackageIndicator
  ],
  templateUrl: './search-result-view-thumbnail-v2.component.html',
  styleUrl: './search-result-view-thumbnail-v2.component.scss'
})
export class SearchResultViewThumbnailV2Component implements AfterViewInit {
  // Injections
  private readonly featureFlagService: FeatureFlagsService = inject(FeatureFlagsService);
  private readonly searchResultSelectionService: SearchResultSelectionsService = inject(SearchResultSelectionsService);

  @Input() isRootObject: boolean;
  @Input() item: SearchObject;
  @Input() searchContainer: SearchContainer;

  ngAfterViewInit(): void {
    if (this.isRootObject) {
      const element = document.getElementById(this.item.artifact_id);
      if (element) {
        element.scrollIntoView({ behavior: 'instant' });

        // Set a small timeout to ensure the element is in view before focusing
        setTimeout(() => {
          // Make the element focusable if it isn't already
          if (!element.hasAttribute('tabindex')) {
            element.setAttribute('tabindex', '-1');
          }

          element.focus({ preventScroll: true });
        }, 100);
      }
    }
  }

  getRouterLink(item: SearchObject) {
    if (item.$$refData?.routerLink?.join('/')?.includes('/artifact') && this.objectPageV2) {
      return [...item.$$refData.routerLink, item.artifact_id];
    }
    return item.$$refData?.routerLink
  }

  select(item: SearchObject, event: MouseEvent) {
    event.stopPropagation();
    this.searchResultSelectionService.selectSearchResultItem(item, this.searchContainer, event.shiftKey);
  }

  isCheckboxDisabled(item: SearchObject): boolean {
    return item.$$used || (this.searchResultSelectionService.isSelectionLimitReached(this.searchContainer) && !this.searchContainer.selections.selected[item.artifact_id]);
  }

  readonly objectPageV2 = this.featureFlagService.getFeatureFlags().experimental.useNewObjectPage;
}
